import React from "react";

import { ALL_WORK, WORK_CATEGORIES } from "../constants";
import { CategoryCount, CategoryTab, CategoryTabs } from "../styles";
import { WorkCategoryTabsProps } from "../types";

export const WorkCategoryTabs: React.FC<WorkCategoryTabsProps> = ({
  active,
  counts,
  onChange,
}) => {
  const tabs = [
    ALL_WORK,
    ...WORK_CATEGORIES.map(({ kind, label }) => ({ value: kind, label })),
  ].map(({ value, label }) => ({
    value,
    label,
    count: counts[value],
    isActive: value === active,
    handleClick: () => onChange(value),
  }));

  return (
    <CategoryTabs role="group" aria-label="Work categories">
      {tabs.map(({ value, label, count, isActive, handleClick }) => (
        <CategoryTab
          key={value}
          type="button"
          $isActive={isActive}
          aria-pressed={isActive}
          onClick={handleClick}
        >
          {label}
          <CategoryCount>{count}</CategoryCount>
        </CategoryTab>
      ))}
    </CategoryTabs>
  );
};
